import DaoBase from "./base";
import _ from "underscore";

export default class DaoPlayerData extends DaoBase {
    m_volume_master;
    m_volume_bgm;
    m_volume_cm;
    m_volume_alert;
    m_volume_effect1;
    m_volume_effect2;
    m_volume_effect3;
    m_mute_on_bgm;
    m_mute_on_alert;
    m_mute_on_effect;
    m_mute_on_effect1;
    m_mute_on_effect2;
    m_mute_on_effect3;
    m_channel_id;
    m_channel_name;
    m_shopid;
    m_shopname;
    m_serviceid;
    m_mac;
    m_current_stream;
    m_stream_bgm_id;
    m_stream_bgm_title;
    m_stream_bgm_current;
    m_stream_bgm_duration;
    m_stream_ucmt_id;
    m_stream_ucmt_title;
    m_stream_ucmt_current;
    m_stream_ucmt_duration;
    m_stream_cmt_id;
    m_stream_cmt_title;
    m_stream_cmt_current;
    m_stream_cmt_duration;
    m_stream_mcmt_id;
    m_stream_mcmt_title;
    m_stream_mcmt_current;
    m_stream_mcmt_duration;
    m_stream_live_id;
    m_stream_live_title;
    m_stream_live_current;
    m_stream_live_duration;
    m_stream_cme_id;
    m_stream_cme_title;
    m_stream_cme_current;
    m_stream_cme_duration;
    m_stream_effect1_id;
    m_stream_effect1_title;
    m_stream_effect1_current;
    m_stream_effect1_duration;
    m_stream_effect2_id;
    m_stream_effect2_title;
    m_stream_effect2_current;
    m_stream_effect2_duration;
    m_stream_effect3_id;
    m_stream_effect3_title;
    m_stream_effect3_current;
    m_stream_effect3_duration;
    m_stream_alert_id;
    m_stream_alert_title;
    m_stream_alert_current;
    m_stream_alert_duration;
    m_stream_ad_id;
    m_stream_ad_title;
    m_stream_ad_current;
    m_stream_ad_duration;
    m_stream_local_id;
    m_stream_local_title;
    m_stream_local_current;
    m_stream_local_duration;

    m_milliseconds;

    /** @var {Function} */
    handlerChannelChange;
    /** @var {Function} */
    handlerMediaChange;

    constructor(json, handlerChannelChange, handlerMediaChange) {
        super(json);
        this.m_milliseconds = new Date().getTime();

        this.handlerChannelChange = handlerChannelChange;
        this.handlerMediaChange = handlerMediaChange;
    }

    /**
     * 플레이어에서 전달받은 데이터 파싱
     * @param str {String|null}
     * @returns {DaoPlayerData}
     */
    init(str=null) {
        if(str) {
            // console.log(str);
            let json = {};
            let str_query = str.split("\n");
            if(str_query.length > 1) {
                str_query.forEach(str_value => {
                    const position = str_value.indexOf("=");
                    const key = str_value.substring(0, position);
                    if(key) {
                        let value = str_value.substring(position + 1);

                        switch (key) {
                            case "m_volume_master":
                            case "m_volume_bgm":
                            case "m_volume_cm":
                            case "m_volume_alert":
                            case "m_volume_effect1":
                            case "m_volume_effect2":
                            case "m_volume_effect3":
                            case "m_stream_bgm_current":
                            case "m_stream_bgm_duration":
                            case "m_stream_ucmt_current":
                            case "m_stream_ucmt_duration":
                            case "m_stream_cmt_current":
                            case "m_stream_cmt_duration":
                            case "m_stream_mcmt_current":
                            case "m_stream_mcmt_duration":
                            case "m_stream_live_current":
                            case "m_stream_live_duration":
                            case "m_stream_cme_current":
                            case "m_stream_cme_duration":
                            case "m_stream_effect1_current":
                            case 'm_stream_effect1_duration':
                            case "m_stream_effect2_current":
                            case "m_stream_effect2_duration":
                            case "m_stream_effect3_current":
                            case "m_stream_effect3_duration":
                            case "m_stream_alert_current":
                            case "m_stream_alert_duration":
                            case "m_stream_ad_current":
                            case "m_stream_ad_duration":
                            case "m_stream_local_current":
                            case "m_stream_local_duration":
                                value = Number(value);
                                break;

                            case "m_mute_on_bgm":
                            case "m_mute_on_alert":
                            case "m_mute_on_effect":
                            case "m_mute_on_effect1":
                            case "m_mute_on_effect2":
                            case "m_mute_on_effect3":
                                value = value === "true";
                                break;

                            case "m_channel_id":
                            case "m_channel_name":
                            case "m_shopid":
                            case "m_shopname":
                            case "m_serviceid":
                            case "m_mac":
                            case "m_stream_bgm_id":
                            case "m_stream_bgm_title":
                            case "m_stream_ucmt_id":
                            case "m_stream_ucmt_title":
                            case "m_stream_cmt_id":
                            case "m_stream_cmt_title":
                            case "m_stream_mcmt_id":
                            case "m_stream_mcmt_title":
                            case "m_stream_live_id":
                            case "m_stream_live_title":
                            case "m_stream_cme_id":
                            case "m_stream_cme_title":
                            case "m_stream_effect1_id":
                            case "m_stream_effect1_title":
                            case "m_stream_effect2_id":
                            case "m_stream_effect2_title":
                            case "m_stream_effect3_id":
                            case "m_stream_effect3_title":
                            case "m_stream_alert_id":
                            case "m_stream_alert_title":
                            case "m_stream_ad_id":
                            case "m_stream_ad_title":
                            case "m_stream_local_id":
                            case "m_stream_local_title":
                            default:
                                break;
                        }

                        json[key] = value;
                    }
                });
            }

            // let data = new DaoPlayerData(json);
            // 채널변경
            // if(this.m_channel_id !== data.m_channel_id) {
            //     if(_.isFunction(this.handlerChannelChange)) {
            //         this.handlerChannelChange.call(this, data.m_channel_id);
            //     }
            // }


            const n_stream_name = json["m_current_stream"] || '';
            const n_channel_id = json["m_channel_id"] || '';
            let n_stream = {
                type: n_stream_name,
                at: json[`m_stream_${n_stream_name}_at`] || '',
                id: json[`m_stream_${n_stream_name}_id`] || '',
                title: json[`m_stream_${n_stream_name}_title`] || '',
                current: json[`m_stream_${n_stream_name}_current`] || 0,
                duration: json[`m_stream_${n_stream_name}_duration`] || 0,
            };

            let p_stream = this.stream;
            if(this.m_current_stream !== n_stream_name || p_stream.id !== n_stream.id) {

                let ment_used;
                let ment_title;
                switch(n_stream_name) {
                    case "cmt":
                        ment_used = true;
                        ment_title = '오늘의 편성 재생중';
                        break;
                    case "ucmt":
                        ment_used = true;
                        ment_title = '사용자 지정 방송 재생중';
                        break;
                    case "mcmt":
                        ment_used = true;
                        ment_title = '개점 방송 재생중';
                        break;
                    case "live":
                        ment_used = true;
                        ment_title = '즉시 재생 방송 재생중';
                        break;
                    case "cme":
                        ment_used = true;
                        ment_title = '일반 방송 재생중';
                        break;
                    case "ad":
                        ment_used = true;
                        ment_title = '광고 방송 재생중';
                        break;
                    case "alert":
                        ment_used = true;
                        ment_title = '배달 알림 재생중';
                        break;
                    case "effect1":
                    case "effect2":
                    case "effect3":
                        ment_used = true;
                        ment_title = '기능성 효과음 재생중';
                        break;
                    default:
                        ment_used = false;
                        ment_title = null
                        break;
                }

                if(_.isFunction(this.handlerChannelChange)) {
                    if(ment_used) {
                        this.handlerChannelChange.call(this, ment_title, n_stream);
                    } else {
                        this.handlerChannelChange.call(this, n_channel_id);
                    }
                }

                if(_.isFunction(this.handlerMediaChange)) {
                    this.handlerMediaChange.call(this, n_stream);
                }

                ment_used = null;
                ment_title = null;
            }

            this.serialize(json);

            json = null;
            str_query = null;

            p_stream = null;
            n_stream = null;
        }

        this.m_milliseconds = new Date().getTime();

        str = null;
        return this;
    }

    get channel() {
        return {
            id: this.m_channel_id,
            name: this.m_channel_name,
        }
    }

    /**
     * 스트림정보
     * @returns {{type: string, at: string, id: string, title: string, current: number, duration: number}}
     */
    get stream() {
        return {
            type: this.m_current_stream || '',
            at: this[`m_stream_${this.m_current_stream}_at`] || '',
            id: this[`m_stream_${this.m_current_stream}_id`] || '',
            title: this[`m_stream_${this.m_current_stream}_title`] || '',
            current: this[`m_stream_${this.m_current_stream}_current`] || 0,
            duration: this[`m_stream_${this.m_current_stream}_duration`] || 0,
        }
    }

    /**
     * @returns {string|null}
     */
    get current_stream() {
        return this.m_current_stream;
    }

    /**
     * @returns {number}
     */
    get volume_master() {
        return this.m_volume_master
    }

    /**
     * @returns {number}
     */
    get volume_cm() {
        return this.m_volume_cm;
    }

    /**
     * @returns {number}
     */
    get volume_alert() {
        return this.m_volume_alert;
    }

    /**
     * @returns {number}
     */
    get volume_effect1() {
        return this.m_volume_effect1;
    }

    /**
     * @returns {number}
     */
    get volume_effect2() {
        return this.m_volume_effect2;
    }

    /**
     * @returns {number}
     */
    get volume_effect3() {
        return this.m_volume_effect3;
    }

    /**
     * 배경 볼륨
     * @returns {number}
     */
    get volume_bgm() {
        return this.m_volume_bgm === undefined ? 1 : this.m_volume_bgm;
    }

    /**
     * 멘트 최소 볼륨
     * @returns {number}
     */
    get volume_ment() {
        const volume = Math.min(this.volume_cm, this.volume_alert, this.volume_effect1, this.volume_effect2, this.volume_effect3);
        return volume === undefined ? 1 : volume;
    }

    get mute_on_bgm() {
        return this.m_mute_on_bgm || false;
    }

    get mute_on_alert() {
        return this.m_mute_on_alert || false;
    }

    get mute_on_effect() {
        return this.m_mute_on_effect || false;
    }

    get mute_on_effect1() {
        return this.m_mute_on_effect1 || false;
    }

    get mute_on_effect2() {
        return this.m_mute_on_effect2 || false;
    }

    get mute_on_effect3() {
        return this.m_mute_on_effect3 || false;
    }
}


// WEBPACK FOOTER //
// ./src/modules/dao/player.data.js